import { LiveTranslateService } from '../../services/live-translate.service';
import { CommonModule, formatDate } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ElementRef, SimpleChanges } from '@angular/core';
import { Months } from '../../constants/months';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'custom-year-month-picker',
  standalone:true,
  imports:[TranslateModule,CommonModule,FormsModule],
  templateUrl: './custom-year-month-picker.component.html',
  styleUrls: ['./custom-year-month-picker.component.scss']
})
export class CustomYearMonthPickerComponent implements OnInit {

  @Input() hasIcon: boolean = true;
  @Input() classDate?: string;
  @Input() minValue: Date = new Date(new Date().getFullYear() - 3, new Date().getMonth() + 1, 1)
  @Input() maxValue: Date = new Date(new Date().getFullYear() + 1, new Date().getMonth() + 1, 1)
  @Input() defaultValue: Date = new Date()
  @Output() onDateChange: EventEmitter<any> = new EventEmitter<any>();
  readonly months = Months;
  togglePicker: boolean = false;
  selectedMonth: any = this.defaultValue.getMonth() + 1;
  selectedYear: number = new Date().getFullYear();
  selectedDate: string = '';

  @HostListener('document:click', ['$event.target'])
  public onPageClick(targetElement: any) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.selectedDate = formatDate(new Date(this.selectedYear, this.selectedMonth - 1), 'MM-yyyy', 'en')
      this.togglePicker = false;
    }
  }

  constructor(public elementRef: ElementRef, public liveTranslate: LiveTranslateService) { }

  ngOnInit(): void {
    this.selectedDate = formatDate(this.defaultValue, 'MM-yyyy', 'en');
    this.selectedMonth = this.defaultValue.getMonth() + 1;
    this.selectedYear = this.defaultValue.getFullYear()
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedDate = formatDate(this.defaultValue, 'MM-yyyy', 'en')
    this.selectedMonth = this.defaultValue.getMonth() + 1;
    this.selectedYear = this.defaultValue.getFullYear()

  }

  selectMonth(month: any) {
    if (new Date(this.selectedYear, month) < new Date(this.minValue) || new Date(this.selectedYear, month) > new Date(this.maxValue)) return
    this.selectedMonth = month;
    this.selectedDate = formatDate(new Date(this.selectedYear, this.selectedMonth - 1), 'MM-yyyy', 'en')
    this.onDateChange.emit(new Date(this.selectedYear, this.selectedMonth - 1, 1))
    this.togglePicker = false
  }

  decrementYear() {
    if (this.selectedYear < this.minValue.getFullYear()) return
    this.selectedYear -= 1;
    this.selectedDate = formatDate(new Date(this.selectedYear, this.selectedMonth - 1), 'MM-yyyy', 'en')
    // this.onDateChange.emit(new Date(this.selectedYear, this.selectedMonth - 1, 1))

  }
  incrementYear() {
    if (this.selectedYear >= this.maxValue.getFullYear()) return
    this.selectedYear += 1;
    this.selectedDate = formatDate(new Date(this.selectedYear, this.selectedMonth - 1), 'MM-yyyy', 'en')
    // this.onDateChange.emit(new Date(this.selectedYear, this.selectedMonth - 1, 1))

  }

  selectedDateChanged(event: string) {
    if (!event.includes('-')) return
    const month = parseInt(event.split('-')[0]);
    const year = parseInt(event.split('-')[1]);
    if ((month.toString() == 'NaN' || year.toString() == 'NaN')) return
    if (year < this.minValue.getFullYear() || year >= this.maxValue.getFullYear()) return
    this.selectedYear = year
    this.selectMonth(month);

  }
}
